// RoleType, la clase base, no se exporta: se hereda de MemberRoleType y se
// pisa todo lo que la distingue. Es lo mismo que hace enterprise con sus roles.
import { MemberRoleType } from '@baserow/modules/database/roleTypes'

/**
 * El rol "Lector": ve todo el espacio de trabajo y no cambia nada.
 *
 * Sin licencia, dentro de un espacio solo existen Admin y Miembro, y un
 * Miembro puede borrar una tabla. Este rol es el punto intermedio que de verdad
 * se pide —"que lo vean pero no lo muevan"—, y quien lo hace cumplir es
 * LectorMGPermissionManagerType en el backend: esto es solo el nombre que se
 * elige en la lista de Miembros.
 *
 * `getUid()` devuelve lo que se guarda en WorkspaceUser.permissions, que es
 * texto libre; por eso no hace falta tocar nada del arbol de Baserow para que
 * el rol se pueda asignar por el endpoint de siempre.
 *
 * El alcance es el espacio de trabajo ENTERO. No son los permisos por tabla de
 * Baserow —eso es RBAC y es de pago—, y el nombre no lo insinua a proposito.
 */
// Lo que se guarda en WorkspaceUser.permissions, y los textos que se leen en la
// lista de Miembros. Viven aqui, juntos, porque la pantalla los pide por dos
// caminos distintos: la descripcion sale del tipo de rol y el NOMBRE sale del
// mapa de traducciones de un permission manager (ver permissionManagerTypes).
// Repetirlos en los dos sitios terminaria en un rol que se llama de una forma y
// se describe de otra.
export const UID_LECTOR = 'LECTOR'
export const NOMBRE_LECTOR = 'Lector'
export const DESCRIPCION_LECTOR =
  'Puede ver todo el espacio de trabajo, pero no cambiar nada.'

export class LectorMGRoleType extends MemberRoleType {
  static getType() {
    return 'lector_mg'
  }

  getUid() {
    return UID_LECTOR
  }

  getName() {
    return NOMBRE_LECTOR
  }

  getDescription() {
    return DESCRIPCION_LECTOR
  }
}


// "Sin acceso": entra al espacio pero solo ve las bases y tablas que se le
// compartan (desde "Gestionar miembros"). Es el rol con el que llega quien un
// Encargado invita por correo.
export const UID_SIN_ACCESO = 'SIN_ACCESO'
export const NOMBRE_SIN_ACCESO = 'Sin acceso'
export const DESCRIPCION_SIN_ACCESO =
  'Solo ve las bases y tablas que se le compartan.'

export class SinAccesoMGRoleType extends MemberRoleType {
  static getType() {
    return 'sin_acceso_mg'
  }

  getUid() {
    return UID_SIN_ACCESO
  }

  getName() {
    return NOMBRE_SIN_ACCESO
  }

  getDescription() {
    return DESCRIPCION_SIN_ACCESO
  }
}
